import React from 'react';
import styled from 'styled-components';
import { Grid, Row } from 'react-bootstrap';
import { RighAlignedCol, LeftAlignedCol, StyledButton } from '../StyledPrimitives/StyledPrimitives';

const ColoredRow = styled(Row)`
    background: #0f42a8;
    padding: 5px 20px 5px 20px;
`;

const footer = (props) => (
    <Grid fluid>
        <ColoredRow>
            <LeftAlignedCol xs={6}>
                <h5>Built by: Idan Kimel, Yoni Neeman</h5>
            </LeftAlignedCol>
            <RighAlignedCol xs={6}>
                <StyledButton onClick={() => {window.location = 'mailto:idan.kimel@gmail.com'}}>Contact Me</StyledButton>
            </RighAlignedCol>
        </ColoredRow>
    </Grid>
);

export default footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js